/**
 * Conifguration related to the app
 */

export const APP_ENV = process.env.REACT_APP_ENV || 'qa';

// Refresh token timer of 10 minutes
export const REFRESH_TOKEN_TIMER = 1 * 60 * 1000;

export const HOME_URL =
  process.env.REACT_APP_HOME_URL || 'https://checkout-qa.kanda.co.uk/';

export const DASHBOARD_URL =
  process.env.REACT_APP_DASHBOARD_URL || 'https://dashboard-qa.kanda.co.uk';

export const HOWDENS_URL =
  process.env.REACT_APP_HOWDENS_URL || 'https://howdens-qa.kanda.co.uk';

export const SHOP_CIDS = [
  '56193353-994e-43b2-a754-8f56a3ab9c87', // QA
  '9dbef46d-8671-4307-abf8-283b2738170c', // production
];
